/** Each country's flag, by its code in lower case: drawn the same everywhere, as an emoji's is
 * not (Windows says `EE` for 🇪🇪). Each file is fetched only where it is shown. */
const FLAGS: Record<string, string> = Object.fromEntries(
  Object.entries(
    import.meta.glob<string>('../../../node_modules/flag-icons/flags/4x3/*.svg', {
      eager: true,
      query: '?no-inline',
      import: 'default',
    }),
  ).map(([path, url]) => [path.slice(path.lastIndexOf('/') + 1, -4), url]),
);

/**
 * A country's flag before its name: small, its corners rounded, said by the name beside it and
 * not again; nothing for a code no flag is known for.
 */
export function Flag({ country }: { country: string }) {
  const url = FLAGS[country.toLowerCase()];
  return url === undefined ? null : (
    <img className="flag" src={url} alt="" width={20} height={15} loading="lazy" />
  );
}
